/* eslint-disable */
export const data = [
  {
    id: 1,
    request:
      'Request For an Official Car - Toyota Camry 2021 For Director, Ministry Of Education',
      beneficiary:'Osaigie Osaigbovo',
      department:'Director of Admin & Stores',
      category:'Automobile',
      details:' Lorem ipsum dolor vulputate id nisi non aliquam. Phasellus vel ullamcorper',
      lastUpdated:'12.01.24',
    status: 'Draft',
  },
  { id: 2, request: 'Request Of Xenor Photocopy XP923029 for Ministry of Education,Permanent Secretary Office',
  beneficiary:'Osagie Osaigbovo',
      department:'Florence Osakiodeme',
      category:'Electronics',
      details:' Lorem ipsum dolor vulputate id nisi non aliquam. Phasellus vel ullamcorper',
      lastUpdated:'28.12.20',
  status: 'Pending' },
  {
    id: 3,
    request:
      'Request for HP Deskjet Printer PJ1230 for Ministry of Education,Permanent Secretary Office',
      beneficiary:'Eghonghon Izoduwa',
      department:'Anthony Okungbowa',
      details:' Lorem ipsum dolor vulputate id nisi non aliquam. Phasellus vel ullamcorper',
      category:'Electronics',
      lastUpdated:'23.12.20',
    status: 'Pending',
  },
  {
    id: 4,
    request: 'Request of Executive Office Furniture for Ministry of Education,Permanent Secretary Office',
    beneficiary:'Florence Osakiodeme',
      department:'Osagie Osaigbovo',
      details:' Lorem ipsum dolor vulputate id nisi non aliquam. Phasellus vel ullamcorper',
      category:'Furniture',
      lastUpdated:'23.12.20',
    status: 'Inactive',
  },
  {
    id: 5,
    request: 'Request For an Official Car - Toyota Camry - 2021 For Director, Ministry Of Education',
    details:' Lorem ipsum dolor vulputate id nisi non aliquam. Phasellus vel ullamcorper',
    beneficiary:'Anthony Okungbowa',
      department:'Eghonghon Izoduwa',
      category:'Automobile',
      lastUpdated:'23.12.20',
    status: 'Rejected',
  },
];

export default data;
